import { connect } from 'react-redux';
import { setHeaderTitle } from '../../actions/layout';
import List from './List';

export const ListComponent = List;

export default connect(
  undefined,
  dispatch => ({
    updateHeaderTitle: (title) => dispatch(setHeaderTitle(title))
  })
)(List);



// WEBPACK FOOTER //
// ./src/components/List/index.js